import { useNavigate } from "react-router";

import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import ErrorScreen from "~/modules/app/screens/ErrorScreen";
import LoadingScreen from "~/modules/app/screens/LoadingScreen";

import { useInvoicePeriods } from "../api/useInvoiceAvailablePeriods";
import { useInvoiceCreateForPeriod } from "../api/useInvoiceCreateForPeriod";
import { InvoiceAvailablePeriodsList } from "../components/InvoiceAvailablePeriodsList";

export function InvoicesListScreen() {
    const navigate = useNavigate();

    const invoiceCreateForPeriod = useInvoiceCreateForPeriod();
    const { data, error } = useInvoicePeriods();

    const handleCreateClick = (year: number, month: number) => {
        invoiceCreateForPeriod.createInvoiceAsync(year, month);
    };

    return (
        <GaiaPageLayoutColumn maxWidth="xl">
            {error !== undefined ? (
                <ErrorScreen error={error} />
            ) : data === undefined || data === null ? (
                <LoadingScreen />
            ) : (
                <InvoiceAvailablePeriodsList
                    data={data}
                    onClick={invoiceId => {
                        navigate(invoiceId);
                    }}
                    onCreateClick={handleCreateClick}
                />
            )}
        </GaiaPageLayoutColumn>
    );
}
